module.exports = __webpack_public_path__ + "img/login_dark.51ac522a.svg";